import { render, staticRenderFns } from "./StockIndex.vue?vue&type=template&id=3a094d99&"
import script from "./StockIndex.vue?vue&type=script&lang=ts&"
export * from "./StockIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports